import { Almacen } from "./almacen.model";

export class User {
    public usuarioId: number;
    public apellidoPaterno: string;
    public apellidoMaterno: string;
    public login: string;
    public nombre: string;
    public sNombre: string;
    public token: string;
    public primeraVez: boolean;
    public rolId: number;
    public menu: [];
    public subMenu: [];
    public recordatorioCaducidad:boolean;
    public mensajeCaducidad:string;
    public password: string;
    public sujetoObligadoId?: number;
    public almacenId?: number;
    public razonSocialNombre?: string;
    public almacenNombre?: string;
    public actividadVulnerable?: string;
    public actividadVulnerableId?: number;
    public almacenes?: Almacen[];
}
